import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setAuthToken } from './utils/auth';
import { useAuth } from './contexts/AuthContext';
import { buildApiUrl } from './utils/apiUrl';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await fetch(buildApiUrl('/prod/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Login failed');
      // Store JWT in localStorage
      if (data.token) {
        setAuthToken(data.token);
      }
      login();
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', background: 'linear-gradient(90deg, #232526 0%, #414345 100%)' }}>
      {/* Left Side - Car Image and Text */}
      <Box
        sx={{
          flex: 1,
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          backgroundImage: 'url(/Ferrari-LaFerrari-interior-02.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          p: 6,
        }}
      >
        <Box sx={{ mb: 8 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>Journey Beyond</Typography>
          <Typography variant="h6" gutterBottom>Explore the MotorTrend world.</Typography>
          <Button 
            variant="contained" 
            sx={{ background: '#fff', color: '#d32f2f', fontWeight: 700, mt: 2, px: 4 }}
            onClick={() => window.open('https://www.motortrend.com', '_blank', 'noopener,noreferrer')}
          >
            Explore
          </Button>
        </Box>
      </Box>

      {/* Right Side - Login/Signup Form */}
      <Box
        sx={{
          flex: 1,
          minWidth: 350,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: '#181818',
          color: 'white',
          p: 4,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 400 }}>
          <Typography variant="h6" fontWeight={700} sx={{ letterSpacing: 2, mb: 2 }}>
            <span style={{ fontFamily: 'monospace', fontWeight: 900, fontSize: 24, color: '#d32f2f'  }}>M@ES</span>
          </Typography>
          <Typography variant="h5" fontWeight={700} sx={{ mb: 2, mt: 2, letterSpacing: 1 }}>
            LOG IN
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              value={username}
              onChange={e => setUsername(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{ style: { background: '#232323', color: '#fff' } }}
              InputLabelProps={{ style: { color: '#aaa' } }}
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              fullWidth
              margin="normal"
              InputProps={{ style: { background: '#232323', color: '#fff' } }}
              InputLabelProps={{ style: { color: '#aaa' } }}
            />
            {error && <Typography color="error" variant="body2" sx={{ mt: 1 }}>{error}</Typography>}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 3, mb: 2, background: '#d32f2f', fontWeight: 700, fontSize: 18, py: 1.5, ':hover': { background: '#b71c1c' } }}
              disabled={loading}
            >
              {loading ? 'Logging in...' :  'LOG IN'}
            </Button>
          </form>
         
        </Box>
      </Box>
    </Box>
  );
};

export default Login; 
